import {
  Control,
  Controller,
  FieldErrors,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import { PolicyAction, PolicyFormValues } from '../policy-dialog';
import z from 'zod';

import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

interface ChangeCpanelRoleActionProps {
  setValue: UseFormSetValue<PolicyFormValues>;
  control: Control<PolicyFormValues>;
  watch: UseFormWatch<PolicyFormValues>;
  errors: FieldErrors<PolicyFormValues>;
}
export const ChangeCpanelRoleActionSchema = z.object({
  type: z.literal('Change_cPanel_Role'),
  cPanelIsAdmin: z.string().min(1, 'Role is required.'),
});

export type ChangeCpanelRoleActionType = z.infer<
  typeof ChangeCpanelRoleActionSchema
>;

// Type guard to check if an action is ChangeContactSharingActionType
function isChangeCpanelRoleAction(
  action: PolicyAction
): action is ChangeCpanelRoleActionType {
  return action.type === 'Change_cPanel_Role';
}

export default function ChangeCpanelRoleAction({
  setValue,
  watch,
  control,
  errors,
}: ChangeCpanelRoleActionProps) {
  const actionData = watch('actionData');
  const idx = actionData
    .map((action) => action.type)
    .indexOf('Change_cPanel_Role');
  const actionAtIndex = actionData[idx];
  if (!isChangeCpanelRoleAction(actionAtIndex)) {
    return null;
  }

  const currentAction: ChangeCpanelRoleActionType = actionAtIndex;
  const error: FieldErrors<ChangeCpanelRoleActionType> | undefined =
    errors?.actionData?.[idx];

  return (
    <Stack sx={{ p: 1 }}>
      <Stack gap={2}>
        <Controller
          name={`actionData.${idx}.cPanelIsAdmin`}
          control={control}
          render={() => (
            <TextField
              inputProps={{
                id: 'cPanel-role',
              }}
              InputLabelProps={{
                htmlFor: 'cPanel-role',
              }}
              select
              value={currentAction.cPanelIsAdmin}
              onChange={(event) => {
                setValue(
                  `actionData.${idx}.cPanelIsAdmin`,
                  event.target.value,
                  {
                    shouldValidate: true,
                  }
                );
              }}
              label="cPanel Role"
              sx={{ minWidth: 250 }}
              autoComplete="off"
              error={!!error?.cPanelIsAdmin}
              helperText={error?.cPanelIsAdmin?.message || ' '}
            >
              <MenuItem value={'Admin'}>Admin</MenuItem>
              <MenuItem value={'User'}>User</MenuItem>
            </TextField>
          )}
        />
      </Stack>
    </Stack>
  );
}
